<template>
  <section
    id="price"
    class="price-planning text-center">
    <div class="container">
      <div class="heading">
        <h2 class="title-subhead">Wählen Sie das Paket, welches zu Ihrem Unternehmen passt</h2>
      </div>
      <div class="price-plan-frame">
        <div
          v-for="(plan, key) in plans"
          :key="key"
          class="column bx-shadow">
          <strong class="plan-category">{{ plan.title }}</strong>
          <div class="price-per-month">
            <span class="price"><i class="currency-unit">€ </i>{{ plan.price }}</span>
            <i class="monthly">/ monatlich*</i>
          </div>
          <ul class="about-plan">
            <li>{{ plan.maxEmployees ? 'bis' : 'ab' }}
              <span class="text-bold">{{ plan.maxEmployees || plan.minEmployees }}</span>
              Mitarbeiter
            </li>
          </ul>
        </div>
      </div>
      <span class="pricing-info">* Alle Preise sind Bruttopreise inkl. der gesetzlichen MwSt.</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomePricePlanning',
  data () {
    return {
      plans: [
        {
          title: 'Starter',
          price: '29,90',
          maxEmployees: 10
        },
        {
          title: 'Erweitert',
          price: '49,90',
          maxEmployees: 20
        },
        {
          title: 'Premium',
          price: '89,90',
          maxEmployees: 60
        },
        {
          title: 'Platin',
          price: '129,90',
          minEmployees: 60
        }
      ]

    }
  }
}
</script>

<style scoped>

</style>
